export { default as ProductsColorsFilter } from './ProductsColorsFilter';
